export default "__VITE_ASSET__BUXpiPH2__"